import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import type StateService from 'garaje/services/state';
import type { Root } from 'react-dom/client';

export default class VisitorsSettingsPoliciesNewController extends Controller {
  @service declare reactRenderer: ReactRendererService;
  @service declare state: StateService;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { CreateDraftPolicy } = await import('reactRichComponents/visitors/CreateDraftPolicy');

    this.root = await this.reactRenderer.render(CreateDraftPolicy, 'react__visitors__settings__policies__new', {
      locationId: this.state.currentLocation.id,
    });
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
